import { useSelector } from 'react-redux';

import type { SpartacuxRetentionState } from '../../retention.model';

export const useNewsletterModalVisible = () =>
  useSelector<SpartacuxRetentionState, boolean>(
    (state) => state.retention?.newsletter?.isModalNewsletterVisible || false,
  );
